export const headingLists = {
  nif: 'NIF',
  name: 'Nombre',
  surname: 'Apellidos',
  birthday: 'fecha de nacimiento',
  code: 'Código',
  member: 'Socio',
  iban: 'IBAN',
  periodicity: 'Periodicidad',
  type: 'Tipo',
  status: 'Estado',
  amount: 'Cantidad',
  active: 'Activo',
  located: 'situación',
  presentationDate: 'F. Presentación',
  autonomousRegisteredAt: 'fecha de alta autónomo',
  chargeDate: 'F. Cargo',
  description: 'Descripción',
  numberReceipts: 'No. de recibos',
  totalAmount: 'Importe total',
  headquarters: 'Sede',
  memberReceiptIssueDate: 'Mes de emisión',
  activatedAt: 'Fecha de alta',
  deactivatedAt: 'Fecha de baja',
  chargedAt: 'Fecha de cargo',
  consignment: 'Remesa',
  memberCode: 'Código de socio',
  chargeFromDate: 'Fecha de cobro',
  documentHeaderDate: 'Fecha de Devolución',
  bank_code: 'Código Bancario',
  bank: 'Banco',
  bankName: 'Entidad',
  address: 'Dirección',
  paymentMethod: 'Forma de pago',
  feeType: 'Tipo de cuota',
  receiptIssueDate: 'Fecha emisión de recibo',
  potentialMember: 'Captacion',
  comment: 'Comentarios',
  date: 'Fecha',
  response: 'Respuesta',
  periodicities: 'Cuota',
  documentHeaderId: 'id de documento',
  companyWorkersNumber: 'Nº Trabajadores',
  companyName: 'Empresa',
  province: 'Provincia',
  postalCode: 'Código Postal',
  phones: "Teléfonos",
  town: 'Ciudad',
  exemptFromPayment: 'Exento de pago',
  issueDate: 'Fecha de Emisión',
  number: 'Número',
  urgent: 'Urgente',
  origin: 'Origen',
  associatedProjects: 'Proyecto asociado',
  category: 'Categoría',
  adviser: 'Asesor',
  client: 'Cliente',
  paymentMethods: 'Forma de pago',
  bankReturns: 'Devolución',
  types: 'Forma de pago',
  unpaidAmount: 'Importe impagado',
  unpaidReceipts: 'Recibos impagados',
  shareDataToThirdParties: 'Consiente sesión de datos'
};
